const routes = [
    {
        path: "/graduate/application/evaluation/exams",
        component: () => import("../pages/Index"),
        meta: {
            isAuthenticated: true,
            permission: "graduateapplicationevaluationexam_index"
        }
    }
]

export default routes;
